import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { PaymentWall } from "./PaymentWall";
import { Loader2 } from "lucide-react";

export const PremiumRoute = ({ children, pageName }: { children: React.ReactNode; pageName: string }) => {
  const { data: subscription, isLoading } = useQuery({
    queryKey: ["userSubscription"],
    queryFn: async () => {
      console.log("Fetching user subscription status...");
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        console.log("No authenticated user found");
        return null;
      }

      const { data, error } = await supabase
        .from("user_subscriptions")
        .select("tier")
        .eq("user_id", user.id)
        .maybeSingle();

      if (error) {
        console.error("Error fetching subscription:", error);
        throw error;
      }

      console.log("Subscription data:", data);
      return data;
    },
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }

  // If user has premium subscription, show all content
  if (subscription?.tier === "premium") {
    console.log("User has premium subscription, showing content");
    return <>{children}</>;
  }

  // For free users, wrap the content in PaymentWall
  console.log("User is on free tier, showing payment wall");
  return <PaymentWall pageName={pageName}>{children}</PaymentWall>;
};